import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { fetchOverdueActivitiesCount } from '@user/features/Activity/store'
import { useAppDispatch } from '@user/store/hooks'
import { selectCurrentUser } from '@user/store/authorization'

/**
 * Refreshes the app-wide overdue-activity badge.
 *
 * Writing an activity's status from the calendar moves that count exactly as
 * writing it from the Activity panel does, so the calendar has to refresh it
 * too (the panel does this in its own save handler). Kept as a hook so the
 * store wiring sits behind one import — reaching the root store from inside the
 * calendar's component tree otherwise drags the whole slice graph in with it.
 */
export function useRefreshOverdueCount() {
  const dispatch = useAppDispatch()
  const { userId } = useSelector(selectCurrentUser)

  return useCallback(() => {
    dispatch(fetchOverdueActivitiesCount(userId))
  }, [dispatch, userId])
}
